import React from 'react';

const Fps_details_update = ({ data, onBack }) => {
  const { message, fps_id, device_id, success_list } = data || {};
  let i = 1;

  if (!data) {
    return null;
  }

  return (
    <div id="wrapper">
      <div className="wrapper row3">
        <div id="container">
          <div align="center">
            <br/><br/><br/><br/><br/><br/><br/><br/><br/>
            <div align="center">
             <div
  className="response"
  dangerouslySetInnerHTML={{
    __html: (message || '').replace(/for D\b/g, 'for Dealer')
  }}
></div>

            </div>

            {success_list && success_list.length > 0 ? (
              <>
                <br/>
                <table width="60%">
                  <tbody>
                    <tr className="tableheader">
                      <td colSpan="5">
                        FPS Details {fps_id} (Device Id : {device_id || 'NA'})
                      </td>
                    </tr>
                    <tr className="tableheader">
                      <td>Sl No</td>
                      <td>Dealer Type</td>
                      <td>Dealer Name</td>
                      <td>Dealer UID</td>
                      <td>Dealer Mobile</td>
                    </tr>
                    {success_list.map((item, index) => (
                      <tr key={item.dealerType || index}>
                        <td>{index + 1}</td>
                        <td>{item.dealerTypeName}</td>
                        <td>{item.dealerNameEn || 'NA'}</td>
                        <td>
                          {item.dealerUid && item.dealerUid.length >= 12 
                            ? `XXXX-XXXX-${item.dealerUid.substring(8, 12)}`
                            : 'Not Available'
                          }
                        </td>
                        <td>{item.dealerMobile || 'NA'}</td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </>
            ) : (
              <div className='response' style={{ marginTop: '20px', color: '#666' }}>
                No dealer details available for this FPS.
              </div>
            )}
            <br/><br/>
            <button onClick={onBack} className="button button2">&larr; Back</button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Fps_details_update;